/***************************************************************************************************
 * Zone JS Flags
 * Ensure zone.js properly patches all async operations including HTTP requests
 * This fixes the change detection issue where async data updates don't trigger UI re-renders
 */

// Ensure zone.js patches all macroTasks (including XHR/fetch HTTP requests)
// This is critical for Angular change detection to work with HTTP responses
(window as any).__Zone_disable_requestAnimationFrame = false;
(window as any).__Zone_disable_on_property = false;
(window as any).__Zone_enable_cross_context_check = true;

// Ensure all events are patched for proper change detection
// This includes click, input, change events that should trigger UI updates
(window as any).__zone_symbol__UNPATCHED_EVENTS = [];
